/* eslint-disable import/extensions*/
import React from 'react';
import styled, { css } from 'styled-components';
import { Link } from 'gatsby';
/* eslint-enable import/extensions*/

const Base = styled.ol`
	padding-top: 10px;
	list-style: none;
	margin: 0;
	& li a,
	& li {
		font-family: 'Raleway', 'Helvetica Neue', Helvetica, Arial, sans-serif;
		font-size: 12px;
		line-height: 24px;
		font-weight: 400;
		text-transform: uppercase;
		letter-spacing: 2px;
		font-weight: 700;
		font-size: 11px;
		font-weight: 600;
		text-decoration: none;
		display: inline-block;
		color: #fff;
	}
	& > li + li:before {
		padding: 0 8px;
		color: #ccc;
		content: '/';
	}
	& > li:last-child > a {
		color: #777;
		pointer-events: none;
		cursor: default;
	}
	@media (min-width: 831px) {
		float: right;
	}
	${props =>
		props.dark &&
		css`
			& li a,
			& li {
				color: #444;
			}
		`};
`;

const Breadcrumb = ({ crumbs, ...rest }) => {
	const crumbsArr = crumbs.map(crumb => {
		return (
			<li key={crumb.name}>
				<Link to={crumb.link}>{crumb.name}</Link>
			</li>
		);
	});
	return <Base {...rest}>{crumbsArr}</Base>;
};

export default Breadcrumb;
